var registered = {};
var requested = {};
var received = {};

export function registerBatched(key, ids, fetchF) {
	return (dispatch) => {
		// Only use string keys
		ids = _.map(ids, String);

		// Filter out ids already in registered, requested, or received
		ids = _.reject(ids, (id) => {
			return _.any([registered, requested, received], (collection) => {
				return (key in collection) && _.includes(collection[key], id);
			});
		});

		// Only continue if there are at least one id left
		if (ids.length == 0) { return; }

		addIDsToStage(registered, key, ids);

		// Registers a new timeout to trigger the fetch function
		setTimeout(() => {

			// Clear out the registered IDs
			var requestIDs = registered[key];

			// If requestIDs if empty, a previous handler must have requested our IDs
			if (requestIDs.length == 0) { return; }

			// Move IDs into requested from registered
			registered[key] = [];
			addIDsToStage(requested, key, requestIDs);

			dispatch(fetchF(requestIDs)).then(() => {
				requested[key] = _.difference(requested[key], requestIDs);
				addIDsToStage(received, key, requestIDs);
			})
		}, BATCH_TIMEOUT);
	}
}

function addIDsToStage(collection, key, ids) {
	if (!(key in collection)) {
		collection[key] = [];
	}
	collection[key] = collection[key].concat(ids);
}

// Hopefully long enough for render delays not trip us up
// But not so slow as to delay the user's experience
var BATCH_TIMEOUT = 50;


// WEBPACK FOOTER //
// ./modules/lib/actions/BatchingActions.js